/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
 faArrowRight,
 faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import masterFunction from '../master/master.functions';
import notification from '../../components/notification.component';
import Masterselected  from '../../components/masterSelect.component';
import DataTable from 'react-data-table-component';
import table from './traspaso.table';
import { ConfigContext } from '../../context/config.context';
import traspasoFunction from './transpaso.function';
import utils from '../../utils/utils.functions';


const Traspaso = () => {

  const { config } = useContext(ConfigContext);
  const [master, setMaster] = useState([]);
  const [query, setQuery] = useState({
    origen: 'null',
    destino: 'null',
  });
  const [origendata, setOrigenData] = useState([]);
  const [destinodata, setDestinoData] = useState([]);
  const [waitPass, setWaitPass] = useState([]);
  const [waitPassD, setWaitPassD] = useState([]);
  const [toggleo, setToggleo] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [selectd, setSelect] = useState(false);

  useEffect(() => {
    listMaster();
  },[]);

  const listMaster = () => {
    masterFunction.listadoFiltro().then((response) => {
      setMaster(response);
    })
  }

  const masterSelected = (element, name) => {
    setQuery({
      ...query,
      [name]: element.target.value,
    });
    setOrigenData([]);
    setDestinoData([]);
  }

  const consultarGuias = () => {
    let validate = true;
    if (query.origen === 'null' || query.destino === 'null') {
      validate = false;
    }
    if (query.origen === query.destino) {
      validate = false
    }

    setDestinoData([]);
  
    if (validate) {
      masterFunction.transferenciaData({ origen: query.origen }).then((response) => {
        setOrigenData(response.guiasOrigen);
      })
    } else {
      notification.warning('Las guias master deben ser seleccionadas y diferentes una de otra.')
    }
  }

  const onSelectedGuias = (rows, action) => {
    if (action === 'destino') {
      setWaitPass(rows.selectedRows)
    } else {
      setWaitPassD(rows.selectedRows)
    }
  }

  const passdata = (action) => {
     if (action === 'destino') {
      setDestinoData(values => values.concat(waitPass));
      setWaitPass([]);
      setToggleo(!toggleo);
     } else {
      setOrigenData(values => values.concat(waitPassD));
      setWaitPassD([]);
      setToggled(!toggled);
     }
  } 

  useEffect(() => {
    let valores = origendata.filter(val => !destinodata.includes(val));
    setOrigenData(valores);
  },[toggleo])

  useEffect(() => {
    let valores = destinodata.filter(val => !origendata.includes(val));
    setDestinoData(valores);
  },[toggled])


  const confirmar = () => {
    if (destinodata.length) {
      const idsGuias = destinodata.map((e) => e.id);
      traspasoFunction.traspasar({ guias: idsGuias, destino: query.destino }).then((response) => {
        if (response.guias_traspasadas) {
          cleanData();
          notification.success();
        } else {
          notification.warning('Las guias no fueron traspasadas, ocurrio un error');
        }
      })
    } else {
      notification.warning('No existen guias seleccionadas para ser transferidas');
    }
  }

  const cleanData = () => {
    setDestinoData([]);
    setOrigenData([]);
    setWaitPass([]);
    setWaitPassD([]);
    setSelect(!selectd);
    setQuery({
      origen: 'null',
      destino: 'null',
    });
  }

  return (
    <Card>
      <Row>
        <Col lg={5}>
          <div className="grupo-input">
            <small>Guia master de origen</small>
            <Masterselected 
              data={master} 
              errors={''} 
              name="origen" 
              onSelected={(element, name) => masterSelected(element, name)}
              reset={selectd}
            />
          </div>
          <div className="grupo-input">
            <small>Guia master destino</small>
           <Masterselected 
            data={master}
            errors={''}
            name="destino"
            onSelected={(element, name) => masterSelected(element, name)}
            reset={selectd}
            />
          </div>
          <div className="grupo-input mt-2">
             <button onClick={consultarGuias} type="button" className="btnx btnx-warn mb-2">
               Consultar guias
             </button>{' '}
             <button disabled={destinodata.length ? false : true} onClick={confirmar} type="button" className="btnx btnx-warn mb-2">
               Confirmar traspaso
             </button>
          </div>
        </Col>
        <Col lg={7} className="d-flex">
          <div className="frame-transfer">
            <div style={{ paddingLeft: 10 }}>Origen</div>
            <DataTable
              customStyles={table.customStyles}
              columns={table.columns(config.prefijo_correlativo_guia, utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones))}
              data={origendata}
              dense={true}
              pagination={false}
              selectableRows={waitPassD.length ? false : true}
              onSelectedRowsChange={(e) => onSelectedGuias(e, 'destino')}
              noHeader={true}
              clearSelectedRows={toggleo}
            /> 
          </div>
          <div className="control-transfer">
            <div>
               <button disabled={waitPassD.length ? true : false}onClick={() => passdata('destino')} type="button" className="btnx btnx-warn mb-2">
                  <FontAwesomeIcon icon={faArrowRight} />
               </button>
               <button disabled={waitPass.length ? true : false} onClick={() => passdata('origen')} type="button" className="btnx btnx-warn">
                  <FontAwesomeIcon icon={faArrowLeft} />
               </button>
            </div>
          </div>
          <div className="frame-transfer">
          <div style={{ paddingLeft: 10 }}>Destino</div>
          <DataTable
              customStyles={table.customStyles}
              columns={table.columns(config.prefijo_correlativo_guia, utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones))}
              data={destinodata}
              dense={true}
              pagination={false}
              selectableRows={waitPass.length ? false : true}
              onSelectedRowsChange={(e) => onSelectedGuias(e, 'origen')}
              noHeader={true}
              clearSelectedRows={toggled}
              noDataComponent={"Sin contenido consultado"}
            /> 
          </div>
        </Col>
      </Row>
    </Card>
  )
}

export default Traspaso;